import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { detailsVacApp } from "../actions/vaccineAppointmentActions";
import PrintLayout from "../core/printLayout";
import PsychoLayout from "../core/psychoLayout";
// import { psychodiagnostic } from '../utils/printformat';
import dayjs from "dayjs";
import Layout from "../core/Layout";

const options = [
    { id: 1, label: "personal history" },
    { id: 2, label: "premorbid personality" },
    { id: 3, label: "behavioural info" },
    { id: 4, label: "cognitive function" },
];

const ViewPDReport = () => {
    const [patientData, setPatientData] = useState(null);
    const { id } = useParams();
    const navigate = useNavigate();
    const userLogin = useSelector((state) => state.userLogin);
    const { userInfo } = userLogin;
    const vaccineAppList = useSelector((state) => state.vaccineAppDetails);
    const { appointment: { appointment } = {} } = vaccineAppList || {};
    const dispatch = useDispatch();
    const [selectedOptions, setSelectedOptions] = useState(
        options.map((option) => option.label),
    );

    useEffect(() => {
        if (userInfo) {
            dispatch(detailsVacApp(id));
        } else {
            navigate("/signin");
        }
    }, [dispatch, userInfo]);

    useEffect(() => {
        setPatientData(appointment?.psychodiagnostic);
    }, [appointment]);

    let tools = [
        {
            tool: "HAM-A",
            score: appointment?.hamA ? appointment.hamA.score : null,
        },
        {
            tool: "HAM-D",
            score: appointment?.hamD ? appointment.hamD.score : null,
        },
        {
            tool: "YMRS",
            score: appointment?.ymrs ? appointment.ymrs.score : null,
        },
        {
            tool: "CDRS",
            score: appointment?.cdrs ? appointment.cdrs.score : null,
        },
        {
            tool: "PANSS",
            score: appointment?.panss ? appointment.panss.score : null,
        },
        {
            tool: "YBOCS",
            score: appointment?.ybocs ? appointment?.ybocs.score : null,
        },
        {
            tool: "CYBCOS",
            score: appointment?.cybcos ? appointment?.cybcos.score : null,
        },
        {
            tool: "ISAA",
            score: appointment?.isaa ? appointment?.isaa.score : null,
        },
        {
            tool: "BPRS",
            score: appointment?.psychiatric
                ? appointment?.psychiatric.score
                : null,
        },
        {
            tool: "BDI",
            score: appointment?.bdi ? appointment?.bdi.score : null,
        },
    ];

    let psychodiagnostic = () => {
        return `
  <div style="font-family: Arial, sans-serif; font-size:14px;">
    <div style="padding:14px; max-width:900px;">
      <div>
        <h2 style="text-align:center; margin-bottom:20px; font-size:20px;">Psychodiagnostic Report</h2>
${
    appointment &&
    appointment.patient &&
    `
  <div style="font-size:14px; margin-bottom:12px; display:flex; flex-direction:column;">
    
    <!-- Row 1 -->
    <div style="display:flex;">
      <div style="flex:1;">
        <p style="margin:5px;">
          <b>Name:</b> <span>${appointment.patient.firstName.toUpperCase()} ${appointment.patient.lastName.toUpperCase()}</span>
        </p>
      </div>
      <div style="flex:1;">
        <p style="margin:5px;">
          <b>Age:</b> <span>${
              appointment.patient.age
                  ? `${appointment.patient.age} years`
                  : appointment.patient.birthDate &&
                      appointment.patient.birthDate !== "Invalid date"
                    ? `${calculateAge(appointment.patient.birthDate)} years`
                    : "0 years"
          }</span>
        </p>
      </div>
    </div>

    <!-- Row 2 -->
    <div style="display:flex;">
      <div style="flex:1;">
        <p style="margin:5px;">
          <b>Date:</b> <span>${dayjs().format("DD-MM-YYYY")}</span>
        </p>
      </div>
      <div style="flex:1;">
        <p style="margin:5px;">
          <b>Address:</b> <span>${appointment.patient.address || ""}</span>
        </p>
      </div>
    </div>

  </div>
  `
}

        <div style="display:flex; flex-wrap:wrap; gap:1rem; margin-bottom:12px;">
          ${
              patientData?.motherTongue
                  ? `<div style="flex:1 1 calc(33.33% - 1rem);"><strong>Mother Tongue:</strong> ${patientData.motherTongue}</div>`
                  : ""
          }
         ${
             patientData?.education
                 ? `<div style="flex:1 1 calc(33.33% - 1rem);"><strong>Education:</strong> ${patientData.education}</div>`
                 : ""
         }
          ${
              patientData?.maritalStatus
                  ? `<div style="flex:1 1 calc(33.33% - 1rem);"><strong>Marital Status:</strong> ${patientData.maritalStatus}</div>`
                  : ""
          }
          ${
              patientData?.occupation
                  ? `<div style="flex:1 1 calc(33.33% - 1rem);"><strong>Occupation:</strong> ${patientData.occupation}</div>`
                  : ""
          }
          ${
              patientData?.informant
                  ? `<div style="flex:1 1 calc(33.33% - 1rem);"><strong>Informant:</strong> ${patientData.informant}</div>`
                  : ""
          }
          <div style="flex:1 1 calc(33.33% - 1rem);">
            <strong>Referred By Dr. :</strong> ${patientData?.refByDr || ""}
          </div>
          <div style="flex:1 1 calc(33.33% - 1rem);">
            <strong>Reason for Referral:</strong> ${
                patientData?.reasonForReferral || ""
            }
          </div>
        </div>

        ${
            patientData?.chiefComplaints &&
            patientData.chiefComplaints.length > 0
                ? `
          <p style="font-size:16px; margin-top:10px; margin-bottom:8px;"><b>Chief Complaints</b></p>
          ${patientData.chiefComplaints
              .map(
                  (complaint, index) => `
                <div style="margin-bottom:4px;">${index + 1}. ${
                    complaint?.complaint || ""
                }</div>
              `,
              )
              .join("")}
        `
                : ""
        }

        ${
            patientData?.NoOfEpisodes
                ? `<p><b>No Of Episodes:</b> ${patientData.NoOfEpisodes}</p>`
                : ""
        }
        ${
            patientData?.duration
                ? `<p><b>Duration:</b> ${patientData.duration}</p>`
                : ""
        }
        ${patientData?.informant ? "" : "" /* keep spacing consistent */}

        ${
            patientData?.precipitation ||
            patientData?.onset ||
            patientData?.course ||
            patientData?.progression
                ? `
          <h4 style="margin-bottom:10px; font-size:18px;">Nature of Illness</h4>
          <div style="margin-bottom:12px;">
            ${
                patientData?.precipitation
                    ? `${patientData.precipitation} Precipitation`
                    : ""
            }
            ${patientData?.onset ? ` ${patientData.onset} Onset` : ""}
            ${patientData?.course ? ` ${patientData.course} Course` : ""}
            ${
                patientData?.progression
                    ? ` ${patientData.progression} Progression`
                    : ""
            }
          </div>
        `
                : ""
        }

        ${
            patientData?.backInformation
                ? `
          <h4 style="margin-bottom:10px;">Background Information</h4>
          <div style="margin-bottom:12px;">${patientData.backInformation}</div>
        `
                : ""
        }

        <!-- Personal History -->
        ${
            selectedOptions.includes("personal history") &&
            patientData?.backgroundInfo?.personalHistory &&
            Object.values(patientData?.backgroundInfo?.personalHistory).some(
                (v) => v,
            )
                ? `
          <h4>Personal History</h4>
          <div style="margin-bottom:12px;">
            ${Object.entries(patientData?.backgroundInfo?.personalHistory)
                .filter(([_, value]) => value)
                .map(([key, value]) =>
                    value.toLowerCase() === "nil contributory"
                        ? `<div style="margin-bottom:4px;">${key}: ${value}</div>`
                        : `<div style="margin-bottom:4px;">${value}</div>`,
                )
                .join("")}
          </div>
        `
                : ""
        }

        ${
            selectedOptions.includes("premorbid personality") &&
            patientData?.backgroundInfo?.premorbidPersonality &&
            Object.values(patientData.backgroundInfo.premorbidPersonality).some(
                (arr) => Array.isArray(arr) && arr.some((q) => q.answer),
            )
                ? `
          <h4>Premorbid Personality</h4>
          <div style="margin-bottom:12px;">
            ${Object.entries(patientData.backgroundInfo.premorbidPersonality)
                .map(([category, questions]) => {
                    const answered = questions.filter((q) => q.answer);
                    if (!answered.length) return "";
                    return `
                  <div style="margin-bottom:6px;">
                    <p style="margin:0 0 6px 0; font-weight:bold;">${category
                        .replace(/([A-Z])/g, " $1")
                        .toUpperCase()}</p>
                    ${answered
                        .map((q, index) =>
                            q.answer === "Nil contributory"
                                ? ""
                                : `<div style="margin-bottom:4px;">${
                                      index + 1
                                  }. ${q.answer}</div>`,
                        )
                        .join("")}
                  </div>
                `;
                })
                .join("")}
          </div>
        `
                : ""
        }

        <!-- Behavioral Observation (renamed from Behavioural Information) -->
        ${
            selectedOptions.includes("behavioural info") &&
            patientData?.behaviouralInfo
                ? `
          
          ${
              patientData?.behaviouralInfo?.behaviouralEntry
                  ? `<p style="margin-bottom:8px;"><b>Behavioral Observation:</b> <span>${patientData.behaviouralInfo.behaviouralEntry}</span></p>`
                  : ""
          }

          ${
              patientData.behaviouralInfo.generalAppearanceAndBehaviour &&
              Object.values(
                  patientData.behaviouralInfo.generalAppearanceAndBehaviour,
              ).some((v) => v)
                  ? `
            <h4 style="margin-bottom:6px;">General Appearance and Behavior</h4>
            <div style="margin-bottom:8px;">
              ${Object.entries(
                  patientData.behaviouralInfo.generalAppearanceAndBehaviour,
              )
                  .filter(([_, value]) => value)
                  .map(([key, value]) =>
                      value.toLowerCase() === "nil contributory"
                          ? ``
                          : `<div style="margin-bottom:4px;">${value}</div>`,
                  )
                  .join("")}
            </div>
          `
                  : ""
          }

          ${
              patientData.behaviouralInfo.motorBehaviour?.psychomotorActivity ||
              patientData.behaviouralInfo.motorBehaviour?.disturbances?.length >
                  0
                  ? `
            <h4 style="margin-bottom:6px;">Motor Behaviour</h4>
            <div style="margin-bottom:8px;">
              <p style="margin:0;">
                ${
                    patientData.behaviouralInfo.motorBehaviour
                        .psychomotorActivity || ""
                }
                ${
                    patientData.behaviouralInfo.motorBehaviour.disturbances
                        ?.filter((d) => d)
                        .join(", ") || ""
                }
              </p>
            </div>
          `
                  : ""
          }

          ${
              patientData.behaviouralInfo.speech &&
              Object.values(patientData.behaviouralInfo.speech).some((v) => v)
                  ? `
            <h4 style="margin-bottom:6px;">Speech</h4>
            <div style="margin-bottom:8px;">
              ${Object.entries(patientData.behaviouralInfo.speech)
                  .filter(([_, value]) => value)
                  .map(([key, value]) =>
                      value.toLowerCase() === "nil contributory"
                          ? ``
                          : `<div style="margin-bottom:4px;">${value}</div>`,
                  )
                  .join("")}
            </div>
          `
                  : ""
          }

          ${
              patientData.mood
                  ? `<h4 style="margin-bottom:6px;">Mood</h4><div style="margin-bottom:8px;">${patientData.mood}</div>`
                  : ""
          }
          ${
              patientData.moodInput
                  ? `<h4 style="margin-bottom:6px;">Mood Input</h4><div style="margin-bottom:8px;">${patientData.moodInput}</div>`
                  : ""
          }
          ${
              patientData.additionalInfo1
                  ? `<h4 style="margin-bottom:6px;">Additional Info</h4><div style="margin-bottom:8px;">${patientData.additionalInfo1}</div>`
                  : ""
          }

          ${
              patientData.behaviouralInfo.thought &&
              Object.values(patientData.behaviouralInfo.thought).some(
                  (arr) => arr.length > 0,
              )
                  ? `
            <h4 style="margin-bottom:10px;">Thought</h4>
            ${Object.entries(patientData.behaviouralInfo.thought)
                .map(([category, options]) =>
                    options && options.length
                        ? `<div style="margin-bottom:8px;"><b>${category
                              .replace(/([A-Z])/g, " $1")
                              .toUpperCase()}</b>: ${options
                              .map((opt) =>
                                  opt.toLowerCase() === "nil contributory"
                                      ? ""
                                      : opt,
                              )
                              .join(", ")}</div>`
                        : "",
                )
                .join("")}
          `
                  : ""
          }
        `
                : ""
        }

        <!-- Tools Used (larger font) -->
        ${
            tools &&
            tools.filter(
                (tool) => tool.score !== null && tool.score !== undefined,
            ).length > 0
                ? `
          <div style="margin-top:8px; margin-bottom:8px;">
            <h4 style="font-size:18px; margin-bottom:8px;">Tools Used</h4>
            <div style="display:flex; flex-wrap:wrap; gap:8px;">
              ${tools
                  .filter(
                      (tool) => tool.score !== null && tool.score !== undefined,
                  )
                  .map(
                      (tool) => `
                  <div style="display:inline-block; padding:6px 10px; font-size:15px; border-radius:4px; border:1px solid #eee;">
                    <strong>${tool.tool}</strong> : ${tool.score}
                  </div>`,
                  )
                  .join("")}
            </div>
          </div>
        `
                : ""
        }

        ${
            patientData?.testFinding
                ? `
          <div style="margin-top:12px;">
            <p style="margin:0;"><b>Test Finding</b> - ${patientData.testFinding}</p>
          </div>
        `
                : ""
        }

        <!-- Impression (was 'Interpretations') -->
        ${
            patientData.interpretations
                ? `
          <p style="font-weight:700; margin-top:15px; font-size:16px;">Impression</p>
          <div style="max-width:900px; padding:10px; border:1px solid #ddd; border-radius:5px; font-size:14px;">
            ${patientData.interpretations}
          </div>
        `
                : ""
        }

        <!-- Suggestions on next page -->
        ${
            patientData?.suggestions && patientData.suggestions.length !== 0
                ? `
          <div style="margin-top:20px;">
            <h4 style="font-size:16px; margin-bottom:8px;">Suggestions</h4>
            <div style="font-size:14px; line-height:1.5;">
              ${patientData.suggestions
                  .map(
                      (s, i) =>
                          `<div style="margin-bottom:6px;">${i + 1}. ${s}</div>`,
                  )
                  .join("")}
            </div>
          </div>
        `
                : ""
        }

      </div>
    </div>
  </div>
  `;
    };

    const handleCheckboxChange = (label) => {
        setSelectedOptions((prevSelected) =>
            prevSelected.includes(label)
                ? prevSelected.filter((option) => option !== label)
                : [...prevSelected, label],
        );
    };

    const calculateAge = (date) => {
        if (!date || date === "Invalid date") return 0;
        const birthMoment = dayjs(date);
        const today = dayjs();

        return today.diff(birthMoment, "years"); // Calculate the difference in years
    };

    return (
        <Layout>
            <div className=" mt-4">
                {!patientData ? (
                    <>
                        <p>Please fill the psychodiagnostic form</p>
                        <button onClick={() => navigate(-1)}>Back</button>
                    </>
                ) : (
                    <>
                        <PsychoLayout
                            html={psychodiagnostic}
                            category={"forms"}
                        ></PsychoLayout>
                        <div
                            style={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignContent: "flex-start",
                                gap: "20px",
                            }}
                        >
                            <div style={{ fontSize: "10px" }}>
                                <div
                                    style={{
                                        padding: "16px",
                                        maxWidth: "900px",
                                        fontSize: "14px",
                                    }}
                                >
                                    <div>
                                        <h2
                                            style={{
                                                marginBottom: "20px",
                                                textAlign: "center",
                                            }}
                                        >
                                            Psychodiagnostic Report
                                        </h2>
                                        <div style={{ fontSize: "14px" }}>
                                            {appointment?.patient && (
                                                <>
                                                    <div>
                                                        <p>
                                                            Name:{" "}
                                                            <span>
                                                                {appointment.patient.firstName.toUpperCase()}{" "}
                                                                {appointment.patient.lastName.toUpperCase()}
                                                            </span>
                                                        </p>
                                                        <p>
                                                            Age:{" "}
                                                            <span>
                                                                {appointment
                                                                    .patient.age
                                                                    ? `${appointment.patient.age} years`
                                                                    : appointment
                                                                            .patient
                                                                            .birthDate &&
                                                                        appointment
                                                                            .patient
                                                                            .birthDate !==
                                                                            "Invalid date"
                                                                      ? `${calculateAge(
                                                                            appointment
                                                                                .patient
                                                                                .birthDate,
                                                                        )} years`
                                                                      : "0 years"}
                                                            </span>
                                                        </p>
                                                    </div>
                                                    <div>
                                                        <p>
                                                            Date:{" "}
                                                            {dayjs(
                                                                Date.now(),
                                                            ).format(
                                                                "DD-MM-YYYY",
                                                            )}
                                                        </p>
                                                        <p>
                                                            Address:{" "}
                                                            {
                                                                appointment
                                                                    .patient
                                                                    .address
                                                            }
                                                        </p>
                                                    </div>
                                                </>
                                            )}
                                        </div>
                                    </div>

                                    {/* Referred / Reason */}
                                    <div
                                        style={{
                                            display: "flex",
                                            flexWrap: "wrap",
                                            gap: "1rem",
                                        }}
                                    >
                                        {patientData?.motherTongue && (
                                            <div
                                                style={{
                                                    flex: "1 1 calc(33.33% - 1rem)",
                                                }}
                                            >
                                                <strong>Mother Tongue:</strong>{" "}
                                                {patientData.motherTongue}
                                            </div>
                                        )}
                                        {patientData?.maritalStatus && (
                                            <div
                                                style={{
                                                    flex: "1 1 calc(33.33% - 1rem)",
                                                }}
                                            >
                                                <strong>Marital Status:</strong>{" "}
                                                {patientData.maritalStatus}
                                            </div>
                                        )}
                                        {patientData?.education && (
                                            <div
                                                style={{
                                                    flex: "1 1 calc(33.33% - 1rem)",
                                                }}
                                            >
                                                <strong>Education:</strong>{" "}
                                                {patientData.education}
                                            </div>
                                        )}
                                        <div
                                            style={{
                                                flex: "1 1 calc(33.33% - 1rem)",
                                            }}
                                        >
                                            <strong>Referred By Dr. :</strong>{" "}
                                            {patientData?.refByDr}
                                        </div>
                                        <div
                                            style={{
                                                flex: "1 1 calc(33.33% - 1rem)",
                                            }}
                                        >
                                            <strong>
                                                Reason for Referral:
                                            </strong>{" "}
                                            {patientData?.reasonForReferral}
                                        </div>
                                    </div>

                                    {/* Chief Complaints */}
                                    {patientData?.chiefComplaints?.length >
                                        0 && (
                                        <>
                                            <p style={{ fontSize: "16px" }}>
                                                <b>Chief Complaints</b>
                                            </p>
                                            {patientData.chiefComplaints.map(
                                                (complaint, index) => (
                                                    <span key={index}>
                                                        {index + 1}.{" "}
                                                        {complaint?.complaint ||
                                                            ""}{" "}
                                                    </span>
                                                ),
                                            )}
                                        </>
                                    )}

                                    {patientData?.NoOfEpisodes && (
                                        <p>
                                            <b>No Of Episodes</b> :{" "}
                                            {patientData.NoOfEpisodes}
                                        </p>
                                    )}
                                    {patientData?.duration && (
                                        <p>
                                            <b>Duration</b> :{" "}
                                            {patientData.duration}
                                        </p>
                                    )}
                                    {patientData?.informant && (
                                        <p>
                                            <b>Informant</b> :{" "}
                                            {patientData.informant}
                                        </p>
                                    )}
                                    {patientData?.occupation && (
                                        <p>
                                            <b>Occupation</b> :{" "}
                                            {patientData.occupation}
                                        </p>
                                    )}
                                    {/* Nature of illness */}
                                    {(patientData?.precipitation ||
                                        patientData?.onset ||
                                        patientData?.course ||
                                        patientData?.progression) && (
                                        <>
                                            <h4
                                                style={{ marginBottom: "10px" }}
                                            >
                                                Nature of illness
                                            </h4>
                                            <div>
                                                {patientData.precipitation &&
                                                    `${patientData.precipitation} Precipitation`}{" "}
                                                {patientData.onset &&
                                                    ` ${patientData.onset} Onset`}{" "}
                                                {patientData.course &&
                                                    ` ${patientData.course} Course`}{" "}
                                                {patientData.progression &&
                                                    ` ${patientData.progression} Progression`}
                                            </div>
                                        </>
                                    )}

                                    {/* Background Info */}
                                    {patientData?.backInformation && (
                                        <>
                                            <h4
                                                style={{ marginBottom: "10px" }}
                                            >
                                                Background Information
                                            </h4>
                                            <div>
                                                {patientData.backInformation}
                                            </div>
                                        </>
                                    )}

                                    {/* Personal History */}
                                    {selectedOptions.includes(
                                        "personal history",
                                    ) &&
                                        patientData?.backgroundInfo
                                            ?.personalHistory &&
                                        Object.values(
                                            patientData.backgroundInfo
                                                .personalHistory,
                                        ).some((v) => v) && (
                                            <>
                                                <h4>Personal History</h4>
                                                <div>
                                                    {Object.entries(
                                                        patientData
                                                            .backgroundInfo
                                                            .personalHistory,
                                                    )
                                                        .filter(
                                                            ([_, value]) =>
                                                                value,
                                                        )
                                                        .map(
                                                            (
                                                                [key, value],
                                                                idx,
                                                            ) =>
                                                                value.toLowerCase() ===
                                                                "nil contributory" ? (
                                                                    <span
                                                                        key={
                                                                            idx
                                                                        }
                                                                        style={{
                                                                            marginBottom:
                                                                                "5px",
                                                                        }}
                                                                    >
                                                                        {key}:{" "}
                                                                        {value}
                                                                    </span>
                                                                ) : (
                                                                    <span
                                                                        key={
                                                                            idx
                                                                        }
                                                                        style={{
                                                                            marginBottom:
                                                                                "5px",
                                                                        }}
                                                                    >
                                                                        {value}
                                                                    </span>
                                                                ),
                                                        )
                                                        .reduce(
                                                            (prev, curr) => [
                                                                prev,
                                                                ", ",
                                                                curr,
                                                            ],
                                                        )}
                                                </div>
                                            </>
                                        )}

                                    {/* Premorbid Personality */}
                                    {selectedOptions.includes(
                                        "premorbid personality",
                                    ) &&
                                        patientData?.backgroundInfo
                                            ?.premorbidPersonality &&
                                        Object.values(
                                            patientData.backgroundInfo
                                                .premorbidPersonality,
                                        ).some(
                                            (arr) =>
                                                Array.isArray(arr) &&
                                                arr.some((q) => q.answer),
                                        ) && (
                                            <>
                                                <h4>Premorbid Personality</h4>
                                                <div>
                                                    {Object.entries(
                                                        patientData
                                                            .backgroundInfo
                                                            .premorbidPersonality,
                                                    ).map(
                                                        (
                                                            [
                                                                category,
                                                                questions,
                                                            ],
                                                            idx,
                                                        ) => {
                                                            const answered =
                                                                questions.filter(
                                                                    (q) =>
                                                                        q.answer,
                                                                );
                                                            if (
                                                                !answered.length
                                                            )
                                                                return null;
                                                            return (
                                                                <div key={idx}>
                                                                    <p
                                                                        style={{
                                                                            marginBottom:
                                                                                "5px",
                                                                            fontWeight:
                                                                                "bold",
                                                                        }}
                                                                    >
                                                                        {category
                                                                            .replace(
                                                                                /([A-Z])/g,
                                                                                " $1",
                                                                            )
                                                                            .toUpperCase()}
                                                                    </p>
                                                                    {answered.map(
                                                                        (
                                                                            q,
                                                                            i,
                                                                        ) =>
                                                                            q.answer !==
                                                                                "Nil contributory" && (
                                                                                <span
                                                                                    key={
                                                                                        i
                                                                                    }
                                                                                    style={{
                                                                                        marginBottom:
                                                                                            "5px",
                                                                                    }}
                                                                                >
                                                                                    {i +
                                                                                        1}

                                                                                    .{" "}
                                                                                    {
                                                                                        q.answer
                                                                                    }
                                                                                </span>
                                                                            ),
                                                                    )}
                                                                </div>
                                                            );
                                                        },
                                                    )}
                                                </div>
                                            </>
                                        )}

                                    {/* Behavioural Info */}
                                    {selectedOptions.includes(
                                        "behavioural info",
                                    ) &&
                                        patientData?.behaviouralInfo && (
                                            <>
                                                <h4>
                                                    Mental Status Examination
                                                </h4>

                                                {patientData.behaviouralInfo
                                                    .behaviouralEntry && (
                                                    <p>
                                                        <b>
                                                            Behavioural
                                                            Information
                                                        </b>{" "}
                                                        -{" "}
                                                        <span>
                                                            {
                                                                patientData
                                                                    .behaviouralInfo
                                                                    .behaviouralEntry
                                                            }
                                                        </span>
                                                    </p>
                                                )}

                                                {/* General Appearance */}
                                                {patientData.behaviouralInfo
                                                    .generalAppearanceAndBehaviour &&
                                                    Object.values(
                                                        patientData
                                                            .behaviouralInfo
                                                            .generalAppearanceAndBehaviour,
                                                    ).some((v) => v) && (
                                                        <>
                                                            <h4>
                                                                General
                                                                Appearance and
                                                                Behavior
                                                            </h4>
                                                            <div>
                                                                {Object.entries(
                                                                    patientData
                                                                        .behaviouralInfo
                                                                        .generalAppearanceAndBehaviour,
                                                                )
                                                                    .filter(
                                                                        ([
                                                                            _,
                                                                            value,
                                                                        ]) =>
                                                                            value,
                                                                    )
                                                                    .map(
                                                                        (
                                                                            [
                                                                                key,
                                                                                value,
                                                                            ],
                                                                            idx,
                                                                        ) =>
                                                                            value.toLowerCase() !==
                                                                                "nil contributory" && (
                                                                                <span
                                                                                    key={
                                                                                        idx
                                                                                    }
                                                                                >
                                                                                    {
                                                                                        value
                                                                                    }
                                                                                </span>
                                                                            ),
                                                                    )
                                                                    .reduce(
                                                                        (
                                                                            prev,
                                                                            curr,
                                                                        ) => [
                                                                            prev,
                                                                            ", ",
                                                                            curr,
                                                                        ],
                                                                    )}
                                                            </div>
                                                        </>
                                                    )}

                                                {/* Motor Behaviour */}
                                                {(patientData.behaviouralInfo
                                                    .motorBehaviour
                                                    ?.psychomotorActivity ||
                                                    patientData.behaviouralInfo
                                                        .motorBehaviour
                                                        ?.disturbances?.length >
                                                        0) && (
                                                    <>
                                                        <h4>Motor Behaviour</h4>
                                                        <div>
                                                            <p>
                                                                {patientData
                                                                    .behaviouralInfo
                                                                    .motorBehaviour
                                                                    .psychomotorActivity ||
                                                                    ""}{" "}
                                                                {patientData.behaviouralInfo.motorBehaviour.disturbances
                                                                    ?.filter(
                                                                        (d) =>
                                                                            d,
                                                                    )
                                                                    .join(", ")}
                                                            </p>
                                                        </div>
                                                    </>
                                                )}

                                                {/* Speech */}
                                                {patientData.behaviouralInfo
                                                    .speech &&
                                                    Object.values(
                                                        patientData
                                                            .behaviouralInfo
                                                            .speech,
                                                    ).some((v) => v) && (
                                                        <>
                                                            <h4>Speech</h4>
                                                            <div>
                                                                {Object.entries(
                                                                    patientData
                                                                        .behaviouralInfo
                                                                        .speech,
                                                                )
                                                                    .filter(
                                                                        ([
                                                                            _,
                                                                            value,
                                                                        ]) =>
                                                                            value,
                                                                    )
                                                                    .map(
                                                                        (
                                                                            [
                                                                                key,
                                                                                value,
                                                                            ],
                                                                            idx,
                                                                        ) =>
                                                                            value.toLowerCase() !==
                                                                                "nil contributory" && (
                                                                                <span
                                                                                    key={
                                                                                        idx
                                                                                    }
                                                                                >
                                                                                    {
                                                                                        value
                                                                                    }
                                                                                </span>
                                                                            ),
                                                                    )
                                                                    .reduce(
                                                                        (
                                                                            prev,
                                                                            curr,
                                                                        ) => [
                                                                            prev,
                                                                            ", ",
                                                                            curr,
                                                                        ],
                                                                    )}
                                                            </div>
                                                        </>
                                                    )}

                                                {patientData.mood && (
                                                    <h6>
                                                        <b>Mood</b>:{" "}
                                                        {patientData.mood}
                                                    </h6>
                                                )}
                                                {patientData.moodInput && (
                                                    <h6>
                                                        <b>Mood Input</b>:{" "}
                                                        {patientData.moodInput}
                                                    </h6>
                                                )}
                                                {patientData.additionalInfo1 && (
                                                    <h6>
                                                        Additional Info:{" "}
                                                        {
                                                            patientData.additionalInfo1
                                                        }
                                                    </h6>
                                                )}

                                                {/* Thought */}
                                                {patientData.behaviouralInfo
                                                    .thought &&
                                                    Object.values(
                                                        patientData
                                                            .behaviouralInfo
                                                            .thought,
                                                    ).some(
                                                        (arr) => arr.length > 0,
                                                    ) && (
                                                        <>
                                                            <h4>Thought</h4>
                                                            {Object.entries(
                                                                patientData
                                                                    .behaviouralInfo
                                                                    .thought,
                                                            ).map(
                                                                (
                                                                    [
                                                                        category,
                                                                        options,
                                                                    ],
                                                                    idx,
                                                                ) =>
                                                                    options?.length >
                                                                        0 && (
                                                                        <p
                                                                            key={
                                                                                idx
                                                                            }
                                                                            style={{
                                                                                marginBottom:
                                                                                    "10px",
                                                                            }}
                                                                        >
                                                                            <b>
                                                                                {category.replace(
                                                                                    /([A-Z])/g,
                                                                                    " $1",
                                                                                )}
                                                                            </b>{" "}
                                                                            :{" "}
                                                                            {options
                                                                                .filter(
                                                                                    (
                                                                                        opt,
                                                                                    ) =>
                                                                                        opt.toLowerCase() !==
                                                                                        "nil contributory",
                                                                                )
                                                                                .join(
                                                                                    ", ",
                                                                                )}
                                                                        </p>
                                                                    ),
                                                            )}
                                                        </>
                                                    )}
                                            </>
                                        )}

                                    {/* Tools */}
                                    {tools?.filter(
                                        (tool) =>
                                            tool.score !== null &&
                                            tool.score !== undefined,
                                    ).length > 0 && (
                                        <div>
                                            <h4>Tool used</h4>
                                            {tools
                                                .filter(
                                                    (tool) =>
                                                        tool.score !== null &&
                                                        tool.score !==
                                                            undefined,
                                                )
                                                .map((tool, idx) => (
                                                    <span
                                                        key={idx}
                                                        style={{
                                                            display:
                                                                "inline-block",
                                                            padding: "5px 10px",
                                                        }}
                                                        z
                                                    >
                                                        {tool.tool} :{" "}
                                                        {tool.score}
                                                    </span>
                                                ))}
                                        </div>
                                    )}

                                    {/* Test Finding */}
                                    {patientData?.testFinding && (
                                        <p>
                                            <b>Test Finding</b> -{" "}
                                            {patientData.testFinding}
                                        </p>
                                    )}

                                    {/* Interpretations */}
                                    {patientData?.interpretations && (
                                        <>
                                            <p
                                                style={{
                                                    fontWeight: 700,
                                                    marginTop: "15px",
                                                }}
                                            >
                                                Interpretations
                                            </p>
                                            <div
                                                style={{
                                                    maxWidth: "900px",
                                                    padding: "10px",
                                                    border: "1px solid #ddd",
                                                    borderRadius: "5px",
                                                }}
                                            >
                                                {patientData.interpretations}
                                            </div>
                                        </>
                                    )}

                                    {/* Suggestions */}
                                    {patientData?.suggestions?.length > 0 && (
                                        <div>
                                            <b>Suggestions:</b>
                                            <p style={{ marginTop: "5px" }}>
                                                {patientData.suggestions.map(
                                                    (s, i) => (
                                                        <span key={i}>
                                                            {i + 1}. {s}
                                                            <br />
                                                        </span>
                                                    ),
                                                )}
                                            </p>
                                        </div>
                                    )}
                                </div>
                            </div>

                            <div
                                style={{
                                    padding: "20px",
                                    fontFamily: "Arial, sans-serif",
                                    width: "20%",
                                }}
                            >
                                <h3 style={{ color: "#0288d1" }}>
                                    Select Sections:
                                </h3>
                                {options.map((option) => (
                                    <div
                                        key={option.id}
                                        style={{ marginBottom: "10px" }}
                                    >
                                        <input
                                            type="checkbox"
                                            id={`checkbox-${option.id}`}
                                            value={option.label}
                                            checked={selectedOptions.includes(
                                                option.label,
                                            )}
                                            onChange={() =>
                                                handleCheckboxChange(
                                                    option.label,
                                                )
                                            }
                                        />
                                        <label
                                            htmlFor={`checkbox-${option.id}`}
                                            style={{
                                                marginLeft: "8px",
                                                color: "#424242",
                                                fontSize: "14px",
                                            }}
                                        >
                                            {option.label}
                                        </label>
                                    </div>
                                ))}
                                <div style={{ marginTop: "20px" }}>
                                    <h4 style={{ color: "#424242" }}>
                                        Selected Options:
                                    </h4>
                                    {selectedOptions.length > 0 ? (
                                        <ul
                                            style={{
                                                color: "#616161",
                                                fontSize: "14px",
                                            }}
                                        >
                                            {selectedOptions.map(
                                                (option, index) => (
                                                    <li key={index}>
                                                        {option}
                                                    </li>
                                                ),
                                            )}
                                        </ul>
                                    ) : (
                                        <p
                                            style={{
                                                color: "#616161",
                                                fontSize: "14px",
                                            }}
                                        >
                                            No options selected.
                                        </p>
                                    )}
                                </div>
                            </div>
                        </div>
                    </>
                )}
            </div>
        </Layout>
    );
};

export default ViewPDReport;
